import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

import { fromStyles } from '@blaze-shared/style-state-feature';

import { LayoutMigrationRunnerService } from '../../services/compat/migrations/layout-migration-runner.service';

@Injectable()
export class StylesMigrationEffects {
  private readonly actions$ = inject(Actions);
  private readonly layoutMigrationRunnerService = inject(LayoutMigrationRunnerService);

  migrateLoadedStyleSheets$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromStyles.loadStyleSheetsReadyForMigration),
      map(({ styleSheets, updateMode, projectId }) => {
        return fromStyles.loadStyleSheetsSuccess({
          styleSheets: this.layoutMigrationRunnerService.migrateStyleSheets(styleSheets),
          updateMode,
          projectId,
        });
      }),
    ),
  );
}
